import { Box, styled, TextField } from "@mui/material";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { SyncLoader } from "react-spinners";
import { toast, ToastContainer, Zoom } from "react-toastify";
import { handleAddClose } from "../../redux/Reducer/ModalSlice";
import { ThemButton } from "../Login/Login.style";
import { ErrorMessage } from "../Volunteer/Volunteer.style";
import "react-toastify/dist/ReactToastify.css";

const StyledInput = styled(TextField)(({ theme }) => ({
  "input[type=number]": {
    MozAppearance: "textfield",
  },
  "input[type=number]::-webkit-outer-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
  "input[type=number]::-webkit-inner-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
}));

const AddSponsor = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState();
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const onSubmit = (data, e) => {
    // alert(JSON.stringify(data));
    setIsLoading(true);
    const formData = new FormData();
    formData.append("sponsor_name", data.sponsor_name);
    formData.append("spon_phone", data.spon_phone);
    formData.append("spon_email", data.spon_email);
    formData.append("spon_address", data.spon_address);
    formData.append("cont_person_nm", data.cont_person_nm);
    formData.append("cont_person_ph", data.cont_person_ph);
    fetch(
      `${process.env.REACT_APP_API_URL}/api/createSponsor`,
      {
        method: "POST",
        body: formData,
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.success === true) {
          toast.success("Sponsor Add successful", {
            position: toast.POSITION.TOP_CENTER,
          });
          dispatch(handleAddClose());
        } else if (data.duplicate === true) {
          toast.error("This sponsor is already exists!!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box sx={{ p: "20px" }}>
        <Box sx={{ pb: "20px" }}>
          <TextField
            size="small"
            fullWidth
            label="Sponsor Name*"
            variant="outlined"
            {...register("sponsor_name", { required: true })}
          />
          {errors?.sponsor_name?.type === "required" && (
            <ErrorMessage>Sponsor Name is required*</ErrorMessage>
          )}
        </Box>

        <Box sx={{ pb: "20px" }}>
          <StyledInput
            type="number"
            size="small"
            fullWidth
            label="Sponsor Phone*"
            variant="outlined"
            {...register("spon_phone", {
              required: true,
              maxLength: 11,
              minLength: 11,
            })}
          />
          {errors?.spon_phone?.type === "required" && (
            <ErrorMessage>Sponsor phone number is required*</ErrorMessage>
          )}
          {errors?.spon_phone?.type === "maxLength" && (
            <ErrorMessage>Sponsor phone number maximum 11 digit</ErrorMessage>
          )}
          {errors?.spon_phone?.type === "minLength" && (
            <ErrorMessage>Sponsor phone number must be 11 digit</ErrorMessage>
          )}
        </Box>

        <Box sx={{ pb: "20px" }}>
          <TextField
            type="email"
            size="small"
            fullWidth
            label="Sponsor Email"
            variant="outlined"
            {...register("spon_email", {
              // required: true,
              pattern: /^\S+@\S+$/i,
            })}
          />
          {errors?.spon_email?.type === "required" && (
            <ErrorMessage>Sponsor Name is required*</ErrorMessage>
          )}
          {errors?.spon_email?.type === "pattern" && (
            <ErrorMessage>This is not email account*</ErrorMessage>
          )}
        </Box>

        <Box sx={{ pb: "20px" }}>
          <TextField
            size="small"
            fullWidth
            label="Sponsor Address"
            variant="outlined"
            {...register("spon_address", {
              // required: true
            })}
          />
          {errors?.spon_address?.type === "required" && (
            <ErrorMessage>Sponsor Address is required*</ErrorMessage>
          )}
        </Box>

        <Box sx={{ pb: "20px" }}>
          <TextField
            size="small"
            fullWidth
            label="Contact person"
            variant="outlined"
            {...register("cont_person_nm", {
              // required: true
            })}
          />
          {errors?.cont_person_nm?.type === "required" && (
            <ErrorMessage>Contact person Name is required*</ErrorMessage>
          )}
        </Box>

        <Box sx={{ pb: "20px" }}>
          <StyledInput
            type="number"
            size="small"
            fullWidth
            label="Phone Number of Contact Person"
            variant="outlined"
            {...register("cont_person_ph", {
              // required: true,
              maxLength: 11,
              minLength: 11,
            })}
          />
          {errors?.cont_person_ph?.type === "required" && (
            <ErrorMessage>
              Contact person Phone Number is required*
            </ErrorMessage>
          )}

          {errors?.cont_person_ph?.type === "maxLength" && (
            <ErrorMessage>
              Contact person Phone Number maximum 11 digit
            </ErrorMessage>
          )}
          {errors?.cont_person_ph?.type === "minLength" && (
            <ErrorMessage>
              Contact person Phone Number must be 11 digit
            </ErrorMessage>
          )}
        </Box>
      </Box>

      <Box sx={{ mb: "15px", display: "flex", justifyContent: "center" }}>
        {isLoading ? (
          <ThemButton
            style={
              {
                //   width: "30%",
              }
            }
            type="submit"
          >
            <SyncLoader color="#FFFFFF" size={8} />
          </ThemButton>
        ) : (
          <ThemButton
            style={
              {
                //   width: "30%",
              }
            }
            type="submit"
          >
            Add Sponsor
          </ThemButton>
        )}

        <ToastContainer
          autoClose={2000}
          limit={1}
          transition={Zoom}
          toastStyle={{ border: "2px solid crimson" }}
        />

        {/* <ThemButton type="submit">Add User Level</ThemButton> */}
      </Box>
    </form>
  );
};

export default AddSponsor;
